<template>
  <div fluid style="max-width: 100vw,heirht : 100vw">
    <v-responsive height="1000px">
      <transition name="slide-fade">
        <v-row id="point1" justify="center" class="mb-8" v-show="visible1">
          <v-col cols="5" align="right">
            <img src="../assets/point1.png" width="118px" />
          </v-col>
          <v-col cols="7" align="left">
            <p class="text">開設に必要な内容は準備してあります！</p>
            <ul class="text2">
              <li>申請書類</li>
              <li>よくある質問</li>
              <li>保健事業の紹介</li>
              <li>ｅｔｃ…</li>
            </ul>
          </v-col>
        </v-row>
      </transition>

      <transition name="slide-fade">
        <v-row id="point2" justify="center" class="mb-8" v-show="visible2">
          <v-col cols="5" align="right">
            <img src="../assets/point2.png" width="123px" />
          </v-col>
          <v-col cols="7" align="left">
            <img src="../assets/phone_tablet.jpg" width="400px" />
            <p class="text">
              スマートフォン・タブレット版標準搭載！
              <br />追加料金はいただきません。
            </p>
          </v-col>
        </v-row>
      </transition>

      <transition name="slide-fade">
        <v-row id="point3" justify="center" class="mb-16" v-show="visible3">
          <v-col cols="5" align="right">
            <img src="../assets/point3.png" width="118px" />
          </v-col>
          <v-col cols="7" align="left">
            <p class="text">
              メンテナンスもおまかせください！
            </p>
            <ul class="text2">
              <li>省庁からの法令通達</li>
              <li>健保連作成の各種申請書の改訂</li>
            </ul>
          </v-col>
        </v-row>
      </transition>
    </v-responsive>
  </div>
</template>

<script>
export default {
  name: "Point",

  data: () => ({
    visible1: false,
    visible2: false,
    visible3: false,
  }),
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      var point1_el = document.getElementById("point1");
      var top1 = point1_el.getBoundingClientRect().top;
      this.visible1 = top1 < window.innerHeight + 50;

      var point2_el = document.getElementById("point2");
      var top2 = point2_el.getBoundingClientRect().top;
      this.visible2 = top2 < window.innerHeight + 50;

      var point3_el = document.getElementById("point3");
      var top3 = point3_el.getBoundingClientRect().top;
      this.visible3 = top3 < window.innerHeight + 50;
    },
  },
};
</script>

<style scoped>
.text {
  margin-top: 20px;
  font-size: 28px;
  letter-spacing: 0.1em;
}

.text2 {
  margin-top: 20px;
  font-size: 20px;
  letter-spacing: 0.1em;
  list-style: none;
}
.slide-fade-enter-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}
</style>
